// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import AwardGeneral from '../_raw/award/icon_award_general.svg';

export default withIconProps(AwardGeneral, { shouldSetDefaultSize: false });
